const swiper03 = new Swiper ('.herbs-carousel', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1.2,
    freeMode: false,
    spaceBetween: 10,
    breakpoints: {
        769:{
              slidesPerView: 3,
          }
      }
})